import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FormEntity } from './form.entity';

/**
 * One action a form runs on submit (notify, create lead, create issue), in `sortOrder`, so
 * a later action can use what an earlier one created. Each is added, configured and
 * switched off on its own (decision F4). The shape of `condition` and `config` per action
 * type is in docs/claude/forms/01-design.md §4–5; the runner arrives with the actions story.
 */
@Index('idx_form_action_form_order', ['fkFormId', 'sortOrder'], {})
@Entity('form_action')
export class FormActionEntity extends BaseEntity {
	@Column('int', { name: 'fk_form__id', unsigned: true })
	public fkFormId!: number;

	// notify | create_lead | create_issue (later: confirmation_email, webhook).
	@Column('varchar', { name: 'actionType', length: 30 })
	public actionType!: string;

	@Column('varchar', { name: 'name', length: 120 })
	public name!: string;

	@Column('int', { name: 'sortOrder', default: () => "'0'" })
	public sortOrder!: number;

	@Column({ type: 'boolean', name: 'isActive', default: true })
	public isActive!: boolean;

	// When the action runs; null = always.
	@Column('json', { name: 'condition', nullable: true })
	public condition!: Record<string, unknown> | null;

	@Column('json', { name: 'config', nullable: true })
	public config!: Record<string, unknown> | null;

	@ManyToOne(() => FormEntity, { createForeignKeyConstraints: false })
	@JoinColumn([{ name: 'fk_form__id', referencedColumnName: 'id' }])
	public form!: FormEntity;
}
